import { render, staticRenderFns } from "./PerguntaView.vue?vue&type=template&id=611c8288&scoped=true"
import script from "./PerguntaView.vue?vue&type=script&lang=js"
export * from "./PerguntaView.vue?vue&type=script&lang=js"
import style0 from "./PerguntaView.vue?vue&type=style&index=0&id=611c8288&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611c8288",
  null
  
)

export default component.exports